import { Color } from '@billy/design-system'
import styled from '@emotion/styled'

export const Separator = styled.span`
  color: ${Color.Grey300};
`
